import { designClosingReason } from '@features/crm/utils/helpers';

import ModalContainer from '@/components/modals/ModalContainer';
import ModalHeader from '@/components/modals/ModalHeader';

const CloseOrderModal = ({
	onCloseModal,
	onSubmit,
	selectedReason,
	setSelectedReason,
	otherReason,
	setOtherReason
}) => {
	const handleReasonSelect = (reason) => {
		setSelectedReason(reason);
		if (reason !== 'other') {
			setOtherReason('');
		}
	};

	return (
		<ModalContainer className="add-pair-modal" onCloseModal={() => {}}>
			<div className="common-popup">
				<ModalHeader title={'Close Order'} onClose={onCloseModal} />
				<div className="common-popup-body">
					<p className="regular-14 gray_dark_02 mb-12">
						Please select the reason for closing the order.
					</p>
					<div className="close-tags d-flex gap-2 pb-3">
						{designClosingReason.map((reason) => (
							<span
								key={designClosingReason.id}
								className={`tag lg cursor-pointer ${selectedReason === reason.label ? 'active' : ''}`}
								onClick={() => handleReasonSelect(reason.label)}
							>
								{reason.label}
							</span>
						))}
					</div>
					{selectedReason === 'Other' && (
						<div className="form-group mt-3">
							<textarea
								placeholder="Enter reason for closing order"
								value={otherReason}
								onChange={(e) => setOtherReason(e.target.value)}
							/>
						</div>
					)}
				</div>
				<div className="modal-footer pt-0">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32 ml-2" onClick={onCloseModal}>
							Cancel
						</button>
						<button
							className="button size32 ml-2"
							onClick={onSubmit}
							disabled={!selectedReason || (selectedReason === 'Other' && !otherReason.trim())}
						>
							Submit
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default CloseOrderModal;
